// extracted by mini-css-extract-plugin
export default {"noResponses":"responses_noResponses__AMlL4","title":"responses_title__YeGPV","responses":"responses_responses__l07wo"};